import Isotope from "isotope-layout";

var iso;

/**
 * Contact grid
 */

window.addEventListener('load', function () {

	var grid = document.querySelector('.grid');

	if (grid === null) {
		return;
	}

	iso = new Isotope(grid, {
		itemSelector: '.element-item',
		layoutMode: 'fitRows'
	});
});

document.addEventListener('input', function (event) {

	if (iso === undefined) {
		return;
	}

	// Only run on our select menu
	if (event.target.id !== 'filterSelect') {
		return;
	}

	var filterValue = event.target.value;

	iso.arrange({
		filter: filterValue,
		sortBy: 'number',
	});

	iso.getFilteredItemElements();
}, false);

/**
 * Download grid
 */

var downloadGrid = document.querySelector('.downloadGrid');
var categoryDownload = document.querySelector('.downloadCategory');

if (downloadGrid !== null && categoryDownload !== null) {
	var downloadIso = new Isotope(downloadGrid, {
		// options
		itemSelector: '.downloadLink',
		layoutMode: 'fitRows'
	});
	// store filter for each group
	var filters = {};
	categoryDownload.addEventListener('input', function (event) {
		var $select = event.target;
		// get group key
		var filterGroup = $select.getAttribute('value-group');
		// set filter for group
		filters[filterGroup] = event.target.value;
		// combine filters
		var filterValue = concatValues(filters);
		// set filter for Isotope
		downloadIso.arrange({filter: filterValue});
		var selectedFilters = downloadIso.getFilteredItemElements();
		selectedFilters.forEach(myfy);

		function myfy(item, index) {
			document.querySelector('.youareshowing .replace').innerHTML = item.getAttribute('data-category').toUpperCase() + "<br>";
		}

		// flatten object by concatting values
		function concatValues(obj) {
			var value = '';
			for (var prop in obj) {
				value += obj[prop];
			}
			return value;
		}
	}, false);
}
